<template>
  <div>
    <Head title="Shoferët mbledhës" />
    <h1 class="mb-8 text-3xl font-bold">Shoferët mbledhës</h1>
    <div class="flex items-center justify-between mb-6">

      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block mt-4 text-gray-700">Aktivë:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null">Aktivë</option>
          <option value="only">Joaktivë</option>
          <option value="with">Të gjithë</option>
        </select>
      </search-filter>

      <Link class="btn-indigo" href="shoferet-mbledhes/krijo">
        <span>Regjistro</span>
        <span class="hidden md:inline"> Shofer të ri</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th></th>
          <th></th>
          <th class="pb-4 pt-6 px-6">Emri & Mbiemri</th>
          <th class="pb-4 pt-6 px-6">Regjionet</th>
          <th class="pb-4 pt-6 px-6">Telefoni</th>
          <th class="pb-4 pt-6 px-6">Email</th>
          <th class="pb-4 pt-6 px-6">Telefoni i dytë</th>
          <th class="pb-4 pt-6 px-6">Krijuar më</th>
          <th class="pb-4 pt-6 px-6">Edituar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="driver in collectingDrivers.data" :key="driver.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="w-px border-t">
            <Link class="flex items-center pl-4 pr-1" :href="`shoferet-mbledhes/${driver.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px" :href="route('impersonate',{id: driver.id})" tabindex="-1">
              <icon name="impersonate" class="block w-6 h-6 fill-indigo-600" />
            </Link>
          </td>
          <td class="border-t px-6 py-4">
              {{ driver.name }}
              <icon v-if="driver.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
          </td>
          <td  class="border-t px-6">
              <span class="mx-0.5 px-2 py-1 bg-indigo-100 rounded-md" v-for="region in driver.regions">{{ region.name }}&nbsp;</span>
          </td>
          <td class="border-t px-6">
              {{ driver.phone }}
          </td>
          <td class="border-t px-6">
              {{ driver.email }}
          </td>
          <td class="border-t px-6">
              {{ driver.second_phone }}
          </td>
          <td class="border-t px-6">
              {{ driver.hr_created_at }}
          </td>
          <td class="border-t px-6">
              {{ driver.hr_updated_at }}
          </td>
        </tr>
        <tr v-if="collectingDrivers.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnje shoferë.</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="flex flex-wrap">
      <select-input v-model="form.per_page"  class="p-0 mt-6 mr-5 w-1/4 lg:w-1/12">
        <option v-if="collectingDrivers.meta.total > 15" value="15">15 / {{collectingDrivers.meta.total}}</option>
        <option v-if="collectingDrivers.meta.total > 30"  value="30">30 / {{collectingDrivers.meta.total}}</option>
        <option v-if="collectingDrivers.meta.total > 50"  value="50">50 / {{collectingDrivers.meta.total}}</option>
        <option v-if="collectingDrivers.meta.total > 100"  value="100">100 / {{collectingDrivers.meta.total}}</option>
        <option :value="collectingDrivers.meta.total">{{collectingDrivers.meta.total}} / {{collectingDrivers.meta.total}}</option>
      </select-input>

      <pagination class="mt-6" :links="collectingDrivers.meta.links" />
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'
import SearchFilter from '@/Shared/SearchFilter'
import SelectInput from '@/Shared/SelectInput'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    DangerFlashMessage,
    SearchFilter,
    SelectInput
  },
  layout: Layout,
  props: {
    collectingDrivers: Object,
    filters: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        per_page: this.collectingDrivers.meta.total < 15 ? this.collectingDrivers.meta.total : this.collectingDrivers.meta.per_page,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/admin/perdoruesit/shoferet-mbledhes', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
  mounted() {
  }
}
</script>
